module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_1000_2000.1e8b51df.png";